import { Button } from 'antd';

type Props = {
  disabled?: boolean;
  loading?: boolean;
  onDownload?: () => void;
};

export const GheIxCsvDownloadButton = ({ disabled, loading, onDownload }: Props) => {
  return (
    <Button
      type="primary"
      disabled={disabled}
      loading={loading}
      onClick={onDownload}
      data-testid="ghe-page5-download-csv"
    >
      {loading ? 'Exporting...' : 'Download Table File'}
    </Button>
  );
};
